<script>
  import Heading from '$lib/components/ui/Heading.svelte'
  import Section from '$lib/components/ui/Section.svelte'
</script>

<Section spacing="first">
  <Heading>Legal notice</Heading>

  <dl>
    <dt>Website Operator</dt>
    <dd>
      Pausly e.U.<br />
      Josef-Gall-Gasse 5/13<br />
      1020 Wien<br />
      Austria<br />
    </dd>

    <dt>Commercial Court</dt>
    <dd>Regional Court Vienna</dd>

    <dt>VAT-No</dt>
    <dd>ATU58027977</dd>
  </dl>
</Section>

<style lang="postcss">
  dl {
    display: grid;
    /* grid-template-columns: auto 1fr; */
    column-gap: 2rem;
    row-gap: 0;
    @media screen and (min-width: 400px) {
      grid-template-columns: auto 1fr;
    }
  }
  dt {
    font-weight: var(--weight-bold);
  }
  dd {
    margin-bottom: 1rem;
  }
</style>
